module.exports = __webpack_public_path__ + "img/1557614066381430787.3435a5c7.png";